package app.components

import dev.fritz2.core.*

data class ModalStore(
    val show: Boolean,
    val message: String,
    val onConfirm: () -> Unit = {}
)

fun RenderContext.warningModal(
    modalStore: Store<ModalStore>,
) {
    modalStore.data.render { modal ->
        if (modal.show) {
            div("fixed z-50 inset-0 bg-gray-900 bg-opacity-60 overflow-y-auto h-full w-full px-4") {
                div("relative top-40 mx-auto shadow-xl rounded-md bg-white max-w-md") {
                    div("flex justify-end p-2") {
                        button("text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center") {
                            svg("w-5 h-5") {
                                attr("fill", "currentColor")
                                attr("viewBox", "0 0 20 20")
                                path {
                                    attr("fill-rule", "evenodd")
                                    attr(
                                        "d",
                                        "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    )
                                    attr("clip-rule", "evenodd")
                                }
                            }
                            clicks handledBy { modalStore.update(ModalStore(show = false, message = "")) }
                        }
                    }

                    div("p-6 pt-0 text-center") {
                        svg("w-20 h-20 text-red-600 mx-auto") {
                            attr("fill", "none")
                            attr("stroke", "currentColor")
                            attr("viewBox", "0 0 24 24")
                            path {
                                attr("stroke-linecap", "round")
                                attr("stroke-linejoin", "round")
                                attr("stroke-width", "2")
                                attr("d", "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z")
                            }
                        }

                        h3("text-xl font-normal text-gray-500 mt-5 mb-6") {
                            +modalStore.current.message
                        }

                        button("text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-base inline-flex items-center px-3 py-2.5 text-center mr-2") {
                            +"Yes, I'm sure"
                            clicks handledBy {
                                modal.onConfirm()
                                modalStore.update(ModalStore(show = false, message = ""))
                            }
                        }

                        button("text-gray-900 bg-white hover:bg-gray-100 focus:ring-4 focus:ring-cyan-200 border border-gray-200 font-medium inline-flex items-center rounded-lg text-base px-3 py-2.5 text-center") {
                            +"No, cancel"
                            clicks handledBy {
                                modalStore.update(ModalStore(show = false, message = ""))
                            }
                        }
                    }
                }
            }
        }
    }
}